// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2SmZW","hidden":"_30BjC","container":"_1cZSO","frame":"_1yPU8"};